<template>
  <el-row class="articleContent" ref="print" id="print">
    <el-col :span="24">
      <el-breadcrumb
        separator-class="el-icon-arrow-right"
        class="margin-top-10"
      >
        <el-breadcrumb-item>{{ articleInfo.extendFeild3 }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ articleInfo.articleTitle }}</el-breadcrumb-item>
      </el-breadcrumb>
      <!-- <div class="printButton">
        <div class="flex">
          <el-button @click="last()" v-show="lastid == null ? false : true"
            >&lt; 上一篇</el-button
          >
          <el-button @click="next()" v-show="nextid == null ? false : true"
            >下一篇 &gt;</el-button
          >
        </div>
        <el-button class="themeButton" @click="pri">打印本页</el-button>
      </div> -->
      <div class="printContent">
        <p class="readCountLabel">
          浏览次数：<span class="readCount">{{
            articleInfo.readCount ? articleInfo.readCount : 0
          }}</span>
        </p>
        <p class="contentHeader">{{ articleInfo.articleTitle }}</p>
        <div class="content" id="content"></div>
      </div>
      <div class="printButton">
        <el-button class="themeButton" @click="pri">打印本页</el-button>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import {
  URL_LAWS_FIND_ONE,
  URL_LAWS_FIND_BEFORE,
  URL_LAWS_FIND_NEXT,
} from "../../../utils/api";
import util from "../../../utils/util";
import { frontHeater } from "../../../utils/md5encryption";
export default {
  name: "ArticleContent",
  data() {
    return {
      articleInfo: {
        // 标题
        articleTitle: "",
        extendFeild3: "专题文章", //栏目名称
        // 浏览次数
        readCount: 0,
      },
      //上侧表的数据

      lastid: "",
      nextid: "",
    };
  },
  mounted() {
    this.getList(this.$route.query.id);
    this.getLastList(this.$route.query.id);
    this.getNextList(this.$route.query.id);
  },
  filters: {
    formatDate: function (value) {
      if (value != undefined) {
        let date = new Date(value);
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? "0" + MM : MM;
        let d = date.getDate();
        d = d < 10 ? "0" + d : d;
        return y + "年" + MM + "月" + d + "日";
      }
    },
  },
  methods: {
    pri() {
      this.$print(this.$refs.print);
    },
    // 获取数据列表
    // getList(val) {
    //   let result = frontHeater(["id"], [val]);
    //   let Url = util.getAjaxUrl("axiosThree");
    //   this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
    //   this.$http.defaults.headers.common["secretSign"] =
    //     result.encryptionString;
    //   this.$http.defaults.headers.common["secretDefinite"] =
    //     result.parameterKey;
    //   this.$http.defaults.headers.common["appCode"] = result.secret;
    //   this.$http.defaults.headers.common["id"] = val;
    //   this.$http.get(Url + `${URL_PORTAL_FIND}/${val}`).then((res) => {
    //     if (res.status == 200) {
    //       this.articleInfo.articleTitle = res.data.infoTitle;
    //       this.articleInfo.readCount = res.data.readNumber;
    //       let list = document.getElementById("content");
    //       list.innerHTML = res.data.infoContent;
    //     }
    //   });
    // },

    getList(val) {
      let Url = util.getAjaxUrl("axiosThree");
      let result = frontHeater(["id"], [val]);
      this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
      this.$http.defaults.headers.common["secretSign"] =
        result.encryptionString;
      this.$http.defaults.headers.common["secretDefinite"] =
        result.parameterKey;
      this.$http.defaults.headers.common["appCode"] = result.secret;
      this.$http.defaults.headers.common["id"] = val;
      this.$http.post(Url + `${URL_LAWS_FIND_ONE}?id=${val}`).then((res) => {
        if (res.status == 200) {
          let list = document.getElementById("content");
          list.innerHTML = res.data.data.content;
          this.articleInfo.readCount = res.data.data.visits;
          this.articleInfo.articleTitle = res.data.data.articleTitle;
          this.titleColor = res.data.data.titleColor;
        }
      });
    },

    // 上一篇
    getLastList(val) {
      let result = frontHeater(["id"], [val]);
      let Url = util.getAjaxUrl("axiosThree");
      this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
      this.$http.defaults.headers.common["secretSign"] =
        result.encryptionString;
      this.$http.defaults.headers.common["secretDefinite"] =
        result.parameterKey;
      this.$http.defaults.headers.common["appCode"] = result.secret;
      this.$http.defaults.headers.common["id"] = val;
      let params = {
        id: val,
        legalType: this.$route.query.type,
      };
      this.$http.post(Url + `${URL_LAWS_FIND_BEFORE}`, params).then((res) => {
        if (res.status == 200) {
          this.lastData = res.data.data;
          if (res.data.data !== null) {
            this.lastId = res.data.data.articleId;
          }
        }
      });
    },
    // 下一篇
    getNextList(val) {
      let result = frontHeater(["id"], [val]);
      let Url = util.getAjaxUrl("axiosThree");
      this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
      this.$http.defaults.headers.common["secretSign"] =
        result.encryptionString;
      this.$http.defaults.headers.common["secretDefinite"] =
        result.parameterKey;
      this.$http.defaults.headers.common["appCode"] = result.secret;
      this.$http.defaults.headers.common["id"] = val;
      let params = {
        id: val,
        legalType: this.$route.query.type,
      };
      this.$http.post(Url + `${URL_LAWS_FIND_NEXT}`, params).then((res) => {
        if (res.status == 200) {
          this.nextData = res.data.data;
          if (res.data.data !== null) {
            this.nextId = res.data.data.articleId;
          }
        }
      });
    },
    last() {
      this.getList(this.lastid);
      this.getLastList(this.lastid);
      this.getNextList(this.lastid);
      this.lastid = "";
      this.nextid = "";
    },
    next() {
      this.getList(this.nextid);
      this.getLastList(this.nextid);
      this.getNextList(this.nextid);
      this.lastid = "";
      this.nextid = "";
    },
  },
};
</script>

<style scoped lang="less">
@import "../../../styles/theme";
.articleContent {
  width: 96%;
  margin: 0 auto;
  padding-top: 10px;
  .printButton {
    width: 100%;
    display: flow-root;
    margin: 20px 0;
  }
  .themeButton {
    background-color: @theme-color;
    border-color: @theme-color;
    color: #ffffff;
    padding: 9px 15px;
    float: right;
    font-size: 12px;
    vertical-align: top;
  }
  .themeButton:hover {
    background-color: #c54949;
  }
  .readCountLabel {
    text-align: right;
    padding-right: 10px;
    margin: 10px 0 15px;
    font-size: 16px;
  }
  .readCount {
    color: #ec1d1d;
    font-weight: 700;
    margin-bottom: 10px;
  }
  .contentHeader {
    color: #ec1d1d;
    border-bottom: 1px solid #ec1d1d;
    font-size: 22px;
    margin-top: 10px !important;
    text-align: center;
    line-height: 38px;
    font-weight: 700;
  }
  .content {
    margin: 20px 0;
    font-size: 17px !important;
    border-bottom: 1px solid #303133;
  }
  .flex {
    display: inline-block;
    width: 90%;
    text-align: center;
    .el-button {
      width: 88px;
      height: 32px;
      line-height: 5px;
      text-align: center;
      padding: 0;
    }
    .el-button:hover {
      color: #7c2121;
      border-color: #b71c1c;
      background-color: #f8e8e8;
    }
    .el-button:active {
      color: #7c2121;
      border-color: #7c2121;
    }
    .el-button:focus {
      color: #7c2121;
      border-color: #b71c1c;
      background-color: #f8e8e8;
    }
  }
  .borderCo {
    padding: 10px;
    border: 1px solid #beac88;
    font-size: 14px;
    line-height: 2;
    color: #303133;
  }
}
el-col {
  margin: 10px 0;
}
</style>
